import { useState } from 'react';

export enum PortalType {
  Team = 'team',
  Hospital = 'hospital',
  PetOwner = 'pet-owner',
}

export const PortalDomain = {
  [PortalType.Team]: 'team-v3',
  [PortalType.Hospital]: 'enterprise',
  [PortalType.PetOwner]: 'myveterinaryhospital',
};

export const PortalLoggerGroup = {
  [PortalType.PetOwner]: 'client-pet-owner',
  [PortalType.Team]: 'client-team-hospital',
  [PortalType.Hospital]: 'client-team-hospital',
};

export const getPortalType = (): PortalType => {
  const type = process.env.REACT_APP_PORTAL_NAME;
  if (type && (Object.values(PortalType) as string[]).includes(type)) {
    return type as PortalType;
  } else {
    return PortalType.Team;
  }
};

export const usePortalType = (): PortalType => {
  const [value] = useState(getPortalType());
  return value;
};

export const getRelease = () => {
  let release: string | undefined;
  let environment: string | undefined;
  let serverEnv = process.env.REACT_APP_SERVER_ENV;
  const sentry = process.env.REACT_APP_SENTRY;
  if (sentry) {
    const buildNumber = process.env.REACT_APP_CODEBUILD_BUILD_NUMBER;
    if (serverEnv && buildNumber) {
      switch (serverEnv) {
        case 'prod':
          environment = 'production';
          break;
        case 'stage':
          environment = 'staging';
          break;
        default:
          environment = 'development';
          break;
      }
      release = `${getPortalType()}-${serverEnv}-${buildNumber}`;
    }
  }
  return { release, serverEnv, environment };
};
